
import React from 'react';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select';

interface ModelSelectionProps {
  selectedModel: string;
  onModelSelect: (model: string) => void;
  disabled?: boolean;
}

export const ModelSelection = ({ 
  selectedModel, 
  onModelSelect, 
  disabled = false 
}: ModelSelectionProps) => {
  return (
    <div className="flex items-center space-x-2">
      <label htmlFor="model-select" className="text-sm font-medium">
        Detection Model:
      </label>
      <Select 
        value={selectedModel} 
        onValueChange={onModelSelect}
        disabled={disabled}
      >
        <SelectTrigger id="model-select" className="w-[180px]">
          <SelectValue placeholder="Select a model" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="auto">Auto (Recommended)</SelectItem>
          <SelectItem value="enhanced">Enhanced Detection</SelectItem>
          <SelectItem value="fast">Fast Detection</SelectItem>
          <SelectItem value="precise">High Precision</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
